import { lazy } from 'react';
import { useRoutes } from 'react-router-dom';

import LoggedInRoutes from "./LoggedInRoutes";
import LoggedOutRoutes from "./LoggedOutRoutes";
import Landing from "../pages/landing";
import AnimateButton from "../Components/@extended/AnimateButton";
import {Button} from "@mui/material";
import {Auth} from "aws-amplify";
import {LoginOutlined} from "@ant-design/icons";
import CommonLayout from '../layout/CommonLayout';
import { useSelector} from "react-redux";

function LoginButton(props){
    console.log("Going to login")
    return (
        <>
            <AnimateButton>
                <Button size="large"
                        onClick={() => Auth.federatedSignIn()}
                        endIcon={<LoginOutlined />}
                        variant="contained"
                >Sign in
                </Button>
            </AnimateButton>
        </>
    )
}

export default function AllRoutes(){
    const isLoggedIn = useSelector((state) => {
        return state.authuser.loggedIn
      });
    let routes_to_use = [
        {
            path: '/',
            element: <CommonLayout layout='landing'/>,
            children: [
                {
                    path: '/',
                    element: <Landing LoginButton={<LoginButton />} />
                }
            ]
        },
        LoggedOutRoutes,
        LoggedInRoutes
    ]
    if (isLoggedIn){
        routes_to_use = [
        LoggedInRoutes
    ]
    }
    return useRoutes(routes_to_use)
}